import { FeatureClassification, IContentAPIFeatureClassification } from "./FeatureClassification";
import { FeatureOptionClassification, IContentAPIFeatureOptionClassification } from "./FeatureOptionClassification";
import { ReferenceCodes, IContentAPIReferenceCodes } from "./ReferenceCodes";

export type ConfigurationState = Array<FeatureState>;
export type IContentAPIConfigurationState = Array<IContentAPIFeatureState>;

export class FeatureStateFactory {
    static create(featureState: IFeatureState): IContentAPIFeatureState {
        return new FeatureState(featureState).serialize();
    }

    static createMany(featureStates: IFeatureState[]): IContentAPIConfigurationState {
        return featureStates.map((featureState: IFeatureState) => FeatureStateFactory.create(featureState));
    }
}

export class ConfigurationStateFactory {
    static create(configurationState: IConfigurationState): IContentAPIConfigurationState {
        return FeatureStateFactory.createMany(configurationState);
    }
}

export class FeatureState {
    protected _featureId: string;
    protected _optionId: string;
    protected _featureClassification?: FeatureClassification;
    protected _optionClassification?: FeatureOptionClassification;
    protected _value?: number | string;
    protected _subItemScope?: string;
    protected _source?: FeatureStateSource;
    protected _featureRefCodes?: ReferenceCodes;
    protected _optionRefCodes?: ReferenceCodes;
    protected _image?: string;

    constructor(featureState: IFeatureState) {
        this._featureId = featureState.featureId;
        this._optionId = featureState.optionId;
        this._featureClassification = featureState.featureClassification ? new FeatureClassification(featureState.featureClassification) : undefined;
        this._optionClassification = featureState.optionClassification ? new FeatureOptionClassification(featureState.optionClassification) : undefined;
        this._value = featureState.value;
        this._subItemScope = featureState.subItemScope;
        this._source = featureState.source;
        this._image = featureState.image;

        if (featureState.featureRefCodes) {
            this._featureRefCodes = new ReferenceCodes(featureState.featureRefCodes);
        }

        if (featureState.optionRefCodes) {
            this._optionRefCodes = new ReferenceCodes(featureState.optionRefCodes);
        }
    }

    serialize(): IContentAPIFeatureState {
        const featureState: IContentAPIFeatureState = {
            featureId: this._featureId,
            optionId: this._optionId
        };

        if (this._featureClassification !== undefined) {
            featureState.featureClassification = this._featureClassification.serialize();
        }

        if (this._optionClassification !== undefined) {
            featureState.optionClassification = this._optionClassification.serialize();
        }

        if (this._value !== undefined) {
            featureState.value = this._value;
        }

        if (this._subItemScope !== undefined) {
            featureState.subItemScope = this._subItemScope;
        }

        if (this._source !== undefined) {
            featureState.source = this._source;
        }

        if (this._featureRefCodes !== undefined) {
            featureState.featureRefCodes = this._featureRefCodes.serialize();
        }

        if (this._optionRefCodes !== undefined) {
            featureState.optionRefCodes = this._optionRefCodes.serialize();
        }

        if (this._image !== undefined) {
            featureState.image = this._image;
        }

        return featureState;
    }
}

export interface IContentAPIFeatureState {
    featureId: string;
    optionId: string;
    featureClassification?: IContentAPIFeatureClassification;
    optionClassification?: IContentAPIFeatureOptionClassification;
    value?: number | string;
    subItemScope?: string;
    source?: FeatureStateSource;
    featureRefCodes?: IContentAPIReferenceCodes;
    optionRefCodes?: IContentAPIReferenceCodes;
    image?: string;
}